var hp = hp || {};
(function () {
/** swiperInstance is global and consistent Swiper function
 * This function works as a wrapper function for idangerous Swiper(http://idangero.us/swiper/)
 * 
 * @param {String} element
 * @param {Object} swiperParams
 * @param {Object} swiperMethods
 * 
 * **/
hp.swiperInstance = function (element, swiperParams, swiperMethods, propsModifier) {
  if ((swiperParams && (swiperParams.constructor !== Object)) || (swiperMethods && (swiperMethods.constructor !== Object))) {
    return false;
  }else if($(element).length === 1){
    if(typeof propsModifier !== 'undefined'){
      swiperParams = propsModifier(element, swiperParams);
    }
    return hp.swiperInit(element, swiperParams, swiperMethods);
  }else if($(element).length > 1){
    // props = [];
    // element.each(function(i, swiper){
    //   var currentClass = '.multiple-swiper.'+$(this).attr("data-id");
    //   props.push(Object.assign({}, swiperParams));
    //   props[i].pagination.el = '.accessory-tile-pagination.' + $(this).attr("data-id");
    //   hp.swiperInstance(currentClass, props[i]);
    // })
    // return false;
    var swipers = [];
    $(element).each(function(i, swiper){
      if(typeof propsModifier !== 'undefined'){
        swiperParams = propsModifier(swiper, swiperParams);
      }
      var currentClass = '.swiper-container'+element+'-'+i;
      //deep cloning, since object.assign only creates references to the objects set as properties
      var props = JSON.parse(JSON.stringify(swiperParams));
      var elementClass = element.replace('.','')
      $(this).attr('data-id', i).addClass(elementClass+'-'+i);
      if(swiperParams.pagination){
        props.pagination.el = $(swiperParams.pagination.el, $(this).closest('.component-wrapper'));
      }
      if(swiperParams.navigation){
        props.navigation.nextEl = $(swiperParams.navigation.nextEl, $(this).closest('.component-wrapper'));
        props.navigation.prevEl = $(swiperParams.navigation.prevEl, $(this).closest('.component-wrapper'))
        if(!props.loop){
          $(props.navigation.prevEl).css({'visibility': 'hidden'});      
        }
      }
      swipers.push(hp.swiperInit(currentClass, props, swiperMethods));
    })
    return swipers;
  }
}

hp.swiperInit = function(element, swiperParams, swiperMethods){
  if (!swiperParams.a11y) {
    swiperParams.a11y = {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
    };
  }
  var swiper = new Swiper(element, swiperParams, swiperMethods);
  if (swiper.length > 1) {
    for (var i = 0; i < swiper.length; i++) {
      if (!swiper[i].initialized) {
        return false
      }
    }
  } else if (!swiper.initialized) {
    return false
  }

  var a11ySwiperHandle = function (a11ySwiper) {
    if ((typeof a11ySwiper === 'object') && !(a11ySwiper instanceof Array)) {
      a11ySwiper = new Array(a11ySwiper);
    }
    for (var i = 0; i < swiper.length; i++) {
      var swiperElement = $(swiper[i].$el);
      swiperElement.find('.swiper-slide').not('.swiper-slide-duplicate').find('.homepage-heading').attr('tabindex', 0);
      swiperElement.find('.swiper-slide.swiper-slide-duplicate').find('.homepage-heading').attr('tabindex', -1);
      swiperElement.find('.swiper-slide.swiper-slide-duplicate').find('.homepage-heading').attr('aria-hidden', true);
      swiperElement.find('.swiper-slide').find('svg').attr('focusable', 'false');
      swiperElement.find('.swiper-slide a').attr('tabindex', 0);
     	swiperElement.find('.swiper-slide a').attr('aria-hidden', false);
      swiperElement.find('.swiper-slide.swiper-slide-duplicate a').attr('tabindex', -1);
      swiperElement.find('.swiper-slide.swiper-slide-duplicate a').attr('aria-hidden', true);
    }
  }
  if (swiperMethods && swiperMethods.a11ySwiper) {
    a11ySwiperHandle(swiper)
  }

  var onlyMobileSwipe = function (mobSwiper) {
    var adjustEvents = function (evSwiper) {
      if (window.innerWidth > 767) {
        evSwiper.detachEvents();
      } else {
        evSwiper.attachEvents();
      }
    }
    if (mobSwiper.length > 1) {
      for (var i = 0; i < mobSwiper.length; i++) {
        adjustEvents(mobSwiper[i]);
      }
    } else {
      adjustEvents(mobSwiper);
    }
  }
  if (swiperMethods && swiperMethods.onlyMobileSwipe) {
    onlyMobileSwipe(swiper);
  }

  var resizeHandler = function (resizeSwiper) {
    var adjustResizeHandler = function (sw) {
      $(window).resize(function () {
        sw.attachEvents()
        sw.resize.resizeHandler();
        sw.resize.orientationChangeHandler();
        if (swiperMethods && swiperMethods.onlyMobileSwipe) {
          onlyMobileSwipe(sw);
        }
      });
    }
    if (resizeSwiper.length > 1) {
      for (var i = 0; i < resizeSwiper.length; i++) {
        adjustResizeHandler(resizeSwiper[i]);
      }
    } else {
      adjustResizeHandler(resizeSwiper);
    }
  }
  if (swiperMethods && swiperMethods.resizeHandler) {
    resizeHandler(swiper)
  }
  var handleCustomMethods = function (cusMethod, cusSwiperEl) {
    if (cusSwiperEl.length > 1) {
      for (var i = 0; i < cusSwiperEl.length; i++) {
        for (var j = 0; j < cusMethod.length; j++) {
          cusMethod[j].method(cusSwiperEl[i])
        }
      }
    } else {
      for (var j = 0; j < cusMethod.length; j++) {
        cusMethod[j].method(cusSwiperEl)
      }
    }
  }
  if (swiperMethods && swiperMethods.customMethods && swiperMethods.customMethods.length > 0) {
    handleCustomMethods(swiperMethods.customMethods, swiper)
  }

  var handleSwiperEvents = function (swEvents, evSwiperEl) {
    if (evSwiperEl.length > 1) {
      for (var i = 0; i < evSwiperEl.length; i++) {
        for (var j = 0; j < swEvents.length; j++) {
          evSwiperEl[i].on(swEvents[j].eventName, swEvents[j].eventMethod.bind(null, evSwiperEl[i]));
        }
      }
    } else {
      for (var j = 0; j < swEvents.length; j++) {
        evSwiperEl.on(swEvents[j].eventName, swEvents[j].eventMethod.bind(null, evSwiperEl));
      }
    }
  }
  if (swiperMethods && swiperMethods.swiperEvents && swiperMethods.swiperEvents.length > 0) {
    handleSwiperEvents(swiperMethods.swiperEvents, swiper)
  }
  return swiper;
}
hp.modifyAriaLabel = function(){
	//console.log('modifyAriaLabel')
	$('.swiper-pagination-bullet:visible').each(function(){
		var container = $(this).closest('.main-container').find('.swiper-container'),
				slide = $(container).find('.swiper-slide')[$(this).index()],
				heading = $(slide).find('a:first'),
				brandName = $(heading).find('.brandName'),
				modelName = $(heading).find('.modelName'),
				label = "slide " + ($(this).index()+1) + " - " + $(brandName).text() + " " + $(modelName).text(),
				pressed = $(this).hasClass('swiper-pagination-bullet-active')
				
		label = label.replace('&reg','').replace('<sup>','').replace('</sup>','')
		
		$(heading).attr('role','link')
		$(container).find('.swiper-wrapper').attr('role','tabpanel')
		$(this).attr({'aria-label':label,'aria-pressed':pressed})
	
	})
}
hp.hideMobileSlidesNotInView = function(){
	if(window.screen.width<768){
		$('.swiper-container.phone-tile-swipe .swiper-slide, .swiper-container.multiple-swiper .swiper-slide').attr('aria-hidden',true)
		$('.swiper-container.phone-tile-swipe .swiper-slide-active, .swiper-container.multiple-swiper .swiper-slide-active').attr('aria-hidden',false)
	}
}
})();

$(document).ready(function(){
  hp.hideMobileSlidesNotInView()
	hp.modifyAriaLabel()
	$('.multiple-swiper .swiper-pagination-bullet, .phone-tile-swipe .swiper-pagination-bullet').on('click',function(e){
		var $target = $(e.target),
				$container = $target.closest('.main-container').find('.swiper-container'),
				slide = $container.find('.swiper-slide:not(.swiper-slide-duplicate)')[$(this).index()],
				heading = $(slide).find('a:first')
		
		window.focusHeading = heading	
		
		$('.swiper-pagination-bullet').attr('aria-pressed',false)
		$target.attr('aria-pressed',true)
	})
});